import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';

import BackOfficeInvitation from 'types/models/back-office-invitation';
import Invitation, { InvitationForProfileSetup, InvitationSid, NewInvitation } from 'types/models/invitation';

import ActionTypes from './constants';

export const loadCurrentEnterpriseInvitations = () =>
  action(ActionTypes.LOAD_CURRENT_ENTERPRISE_INVITATIONS_REQUEST);

export const loadCurrentEnterpriseInvitationsSuccess = (
  invitations: Invitation[]
) =>
  action(ActionTypes.LOAD_CURRENT_ENTERPRISE_INVITATIONS_SUCCESS, {
    invitations
  });

export const loadCurrentEnterpriseInvitationsFailure = (
  message: string,
  error: AxiosError
) =>
  action(
    ActionTypes.LOAD_CURRENT_ENTERPRISE_INVITATIONS_FAILURE,
    { message, error },
    undefined,
    true
  );

export const loadMyInvitations = () =>
  action(ActionTypes.LOAD_MY_INVITATIONS_REQUEST);

export const loadMyInvitationsSuccess = () =>
  action(ActionTypes.LOAD_MY_INVITATIONS_SUCCESS, {});

export const loadMyInvitationsFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.LOAD_MY_INVITATIONS_FAILURE,
    { message, error },
    undefined,
    true
  );

export const loadInvitation = (
  invitationSid: InvitationSid,
  onSuccess: (invitation: InvitationForProfileSetup) => void
) => action(ActionTypes.LOAD_INVITATION_REQUEST, { invitationSid, onSuccess });

export const loadInvitationSuccess = () =>
  action(ActionTypes.LOAD_INVITATION_SUCCESS);

export const loadInvitationFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.LOAD_INVITATION_FAILURE,
    { message, error },
    undefined,
    true
  );

export const addInvitation = (
  newInvitation: NewInvitation,
  onSuccess: () => void
) => action(ActionTypes.ADD_INVITATION_REQUEST, { newInvitation, onSuccess });

export const addInvitationSuccess = (invitation: Invitation) =>
  action(ActionTypes.ADD_INVITATION_SUCCESS, { invitation });

export const addInvitationFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.ADD_INVITATION_FAILURE,
    { message, error },
    undefined,
    true
  );

export const acceptInvitation = (
  invitation: BackOfficeInvitation,
  onSuccess: () => void
) => action(ActionTypes.ACCEPT_INVITATION_REQUEST, { invitation, onSuccess });

export const acceptInvitationSuccess = (invitationSid: InvitationSid) =>
  action(ActionTypes.ACCEPT_INVITATION_SUCCESS, { invitationSid });

export const acceptInvitationFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.ACCEPT_INVITATION_FAILURE,
    { message, error },
    undefined,
    true
  );

export const resendInvitation = (invitationSid: InvitationSid) =>
  action(ActionTypes.RESEND_INVITATION_REQUEST, { invitationSid });

export const resendInvitationSuccess = (invitationSid: InvitationSid) =>
  action(ActionTypes.RESEND_INVITATION_SUCCESS, { invitationSid });

export const resendInvitationFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.RESEND_INVITATION_FAILURE,
    { message, error },
    undefined,
    true
  );

export const deleteInvitation = (
  invitationSid: InvitationSid,
  onSuccess: () => void
) => action(ActionTypes.DELETE_INVITATION_REQUEST, { invitationSid, onSuccess });

export const deleteInvitationSuccess = (invitationSid: InvitationSid) =>
  action(ActionTypes.DELETE_INVITATION_SUCCESS, { invitationSid });

export const deleteInvitationFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.DELETE_INVITATION_FAILURE,
    { message, error },
    undefined,
    true
  );

export const updateInvitation = (
  sid: InvitationSid,
  updatedInvitation: Pick<Invitation, 'role'>
) => action(ActionTypes.UPDATE_INVITATION_REQUEST, { sid, updatedInvitation });

export const updateInvitationSuccess = (
  sid: InvitationSid,
  updatedInvitation: Pick<Invitation, 'role'>
) => action(ActionTypes.UPDATE_INVITATION_SUCCESS, { sid, updatedInvitation });

export const updateInvitationFailure = (message: string, error: AxiosError) =>
  action(
    ActionTypes.UPDATE_INVITATION_FAILURE,
    { message, error },
    undefined,
    true
  );
